import { useEffect } from 'react';
import logo from '../../assets/images/logo.png';
import illustration from '../../assets/images/login_illustration.png';

import { cx } from '@emotion/css';
import * as styles from './loginIntro.style';
import elementObserver from '../utils/shadowDomObserver';
import { Auth } from 'aws-amplify';
import { useHistory } from 'react-router-dom';

export default function LoginIntro({ children, setElm }) {
  const history = useHistory();
  useEffect(() => {
    async function fetchData() {
      const authObserver = await elementObserver({ sel: '.auth-form-container' });
      const parentElm = await authObserver.promise;
      const shadowObserver = await elementObserver({
        context: parentElm.shadowRoot,
        sel: '.auth-container',
      });
      const shadowElm = await shadowObserver.promise;
      shadowElm.classList.remove('auth-container');

      setElm(shadowElm);

      return () => {
        authObserver.clearObserver();
        shadowObserver.clearObserver();
      };
    }

    fetchData();
  }, []);

  useEffect(() => {
    document.querySelectorAll('.auth-form').forEach(async (item) => {
      const shadowObserver = elementObserver({
        context: item.shadowRoot,
        sel: '.section',
      });
      const shadowElm = await shadowObserver.promise;
      const elmSectionObserver = elementObserver({
        context: item.shadowRoot,
        sel: 'amplify-form-section',
      });
      const elms = await elmSectionObserver.promise;
      const styleSheet = document.createElement('style');

      styleSheet.innerHTML = styles.form;

      elms.appendChild(styleSheet);
      shadowElm.classList.remove('section');
    });
  }, []);

  return (
    <section className={cx(styles.container)}>
      <div className={cx(styles.header)}>
        <div className={cx(styles.logoWrapper)}>
           <span className={cx(styles.logoText)}>QuizWhiz</span>
        </div>
        <div className={cx(styles.headerRight)}>
          <button className={cx(styles.signUpBtn)} onClick={() => history.push('/signup')}>Sign up</button>
          <button className={cx(styles.requestDemoBtn)}>Request Demo</button>
        </div>
      </div>

      <div className={cx(styles.contentWrapper)}>
        <div className={cx(styles.decorativeDotsLeft)}></div>
        
        {/* Centralized Auth Card */}
        <div className={cx(styles.authContainer)}>
          <div className={cx(styles.authHeader)}>
            <h2>Login</h2>
            <p>Hey, Enter your details to get sign in to your account</p>
          </div>
          {children}

          <div className={cx(styles.divider)}>
            <span>Or Sign in with</span>
          </div>

          <div className={cx(styles.socialButtons)}>
            <button className={cx(styles.socialBtn)} onClick={() => Auth.federatedSignIn({ provider: 'Google' })}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="18px">
                <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.7 17.74 9.5 24 9.5z"/>
                <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
                <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
                <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
                <path fill="none" d="M0 0h48v48H0z"/>
              </svg>
              Google
            </button>
          </div>
          
          <div className={cx(styles.footerText)}>
            Don't have an account? <b>Request Now</b>
          </div>
        </div>

        <div className={cx(styles.illustrationWrapper)}>
          <img src={illustration} alt="Login Illustration" className={cx(styles.illustrationImage)} />
          <div className={cx(styles.decorativeDotsRight)}></div>
        </div>

      </div>

    </section>
  );
}
